// app/javascript/landing/App.tsx
import React, { useEffect, useState } from "react";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { AnimatePresence, motion } from "framer-motion";

import { HomePage } from "./pages/HomePage";
import { SomosPage } from "./pages/SomosPage";
import { PortfolioPage } from "./pages/PortfolioPage";
import { ContactPage } from "./pages/ContactPage";

export type RouteKey = "inicio" | "somos" | "portafolio" | "contacto";

function resolveRoute(pathname: string): RouteKey {
  if (pathname.startsWith("/somos")) return "somos";
  if (pathname.startsWith("/portafolio")) return "portafolio";
  if (pathname.startsWith("/contacto")) return "contacto";
  return "inicio";
}

export function LandingApp() {
  const [route, setRoute] = useState<RouteKey>(() =>
    resolveRoute(window.location.pathname)
  );

  // Soporte back/forward del navegador
  useEffect(() => {
    const handler = () => setRoute(resolveRoute(window.location.pathname));
    window.addEventListener("popstate", handler);
    return () => window.removeEventListener("popstate", handler);
  }, []);

  // Navegación “SPA” desde el Navbar
  const handleNavigate = (nextRoute: RouteKey, href: string) => {
    if (href !== window.location.pathname) {
      window.history.pushState({}, "", href);
      setRoute(nextRoute);

      // 🔥 Reset scroll al top
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
      });
    }
  };

  const renderRoute = () => {
    switch (route) {
      case "somos":
        return <SomosPage />;
      case "portafolio":
        return <PortfolioPage />;
      case "contacto":
        return <ContactPage />;
      case "inicio":
      default:
        return <HomePage onNavigate={handleNavigate} />;
    }
  };

  return (
    <div className="text-black flex flex-col min-h-screen">
      <Navbar currentRoute={route} onNavigate={handleNavigate} />

      <main className="overflow-x-hidden flex-1 bg-black">
        <AnimatePresence mode="wait">
          <motion.div
            key={route}
            className="bg-white"
            initial={{ opacity: 0, scale: 1, transformOrigin: "top" }}
            animate={{ opacity: 1, scale: 1, transformOrigin: "top" }}
            exit={{ opacity: 0, scale: 1, transformOrigin: "top" }}
            transition={{ duration: 0.35, ease: [0.25, 0.1, 0.25, 1] }}
          >
            {renderRoute()}
          </motion.div>
        </AnimatePresence>
      </main>

      <Footer />
    </div>
  );
}
